import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserDto as User } from '@poker-stats/contracts';

const initialState: {
  users?: Array<User>;
  searchEmail: string;
  sort?: {
    sortKey: string;
    sortOrder: string;
  };
} = {
  searchEmail: '',
};

export const usersReducer = createSlice({
  name: 'users',
  initialState,
  reducers: {
    loadUsers() {},
    setLoadedUsers(state, action) {
      state.users = action.payload;
    },

    activateUser(_state, _action: PayloadAction<number>) {},
    activateUserSuccess(state, action: PayloadAction<User>) {
      const index = state.users?.findIndex((x) => action.payload.id === x.id);
      if (index !== undefined && index !== -1 && state.users) {
        state.users[index] = action.payload;
      }
    },
    changeEmail(state, action: PayloadAction<string>) {
      state.searchEmail = action.payload;
    },

    changeTable(state, action: PayloadAction<{ sortKey: string; sortOrder: string }>) {
      state.sort = action.payload;
    },

    changeUserAvailablePokersiteIds(
      _state,

      _action: PayloadAction<{
        id: number;
        availablePokersiteIds: Array<number>;
      }>,
    ) {},
    changeUserAvailablePokersiteIdsSuccess(state, action: PayloadAction<User>) {
      const index = state.users?.findIndex((x) => action.payload.id === x.id);
      if (index !== undefined && index !== -1 && state.users) {
        state.users[index] = action.payload;
      }
    },

    changeUserSubscription(
      _state,

      _action: PayloadAction<{
        id: number;
        subscription?: number;
      }>,
    ) {},
    changeUserSubscriptionSuccess(state, action: PayloadAction<User>) {
      const index = state.users?.findIndex((x) => action.payload.id === x.id);
      if (index !== undefined && index !== -1 && state.users) {
        state.users[index] = action.payload;
      }
    },

    changeUserSubscriptionDate(
      _state,

      _action: PayloadAction<{
        id: number;
        subscriptionDate?: string;
      }>,
    ) {},
    changeUserSubscriptionDateSuccess(state, action: PayloadAction<User>) {
      const index = state.users?.findIndex((x) => action.payload.id === x.id);
      if (index !== undefined && index !== -1 && state.users) {
        state.users[index] = action.payload;
      }
    },
  },
});

export const {
  loadUsers,
  setLoadedUsers,
  activateUser,
  activateUserSuccess,
  changeEmail,
  changeUserAvailablePokersiteIds,
  changeUserAvailablePokersiteIdsSuccess,
  changeTable,
} = usersReducer.actions;
